export { responsiveJs };

const responsiveJs = function() {

	var $status = $('.slick-count-current'),
		$slickAll = $('.slick-count-all'),
		$slickElement = $('.slick-mobile'),
		$slickElementLarge = $('.slick-mobile-large');

	$(".module-tekstid table").wrap("<div class='overflow-table'></div>");
	//NAV
	$('.hamburger, .user-wrapper').on('click', function (e) {
		$('body, html').toggleClass('overflow-hidden');
		$('body').toggleClass('menu-open');
		$slickElementLarge.slick('setPosition');
		var target = $(e.target),
			$menu = $('.normal-menu'),
			$loginMenu = $('.login-menu');
		if (target.is('.user-wrapper')) {
			$menu.hide();
			$loginMenu.show();
		} else {
			$menu.show();
			$loginMenu.hide();
		}
		$('.hamburger').toggleClass('is-active');
		$('.mobile-navbar').toggleClass('is-active');
	});
	//TABS
	$('ul.row-tabs, ul.row-mobile-tabs').each(function () {

		if (!$(".row-tabs-static").length) {
			var $active, $content, $links = $(this).find('a');
			if (MO.loggedIn()) {
				$active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
			} else if ($('.module-hinnakalkulaator').length) {
				$active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
			} else {
				$active = $($links.filter('[href="' + location.hash + '"]')[1] || $links[1]);
			}

			if (!$('.module-hinnakalkulaator').length) {
				$active.parent().addClass('active');
			}

			$content = $($active[0].hash);
			$links.not($active).each(function () {
				$(this.hash).hide();
			});
		}
		$(this).on('click', 'a', function (e) {
			$active.parent().removeClass('active');
			$content.removeClass('fadeIn').hide();
			$active = $(this);
			$content = $(this.hash);
			$active.parent().addClass('active');
			$content.show().addClass('fadeIn');
			$slickElement.slick('setPosition');
			$slickElementLarge.slick('setPosition');

			activeCalculatorTab = $content.data("what")

			if (activeCalculatorTab == "metsamaa") {
				dataLayer.push({
					'event': 'GAEvent',
					'eventCategory': 'metsakinnistu kalkulaator',
					'eventAction': 'ava metsakinnistu kalkulaator'
				});
			} else if (activeCalculatorTab == "raieoigus") {
				dataLayer.push({
					'event': 'GAEvent',
					'eventCategory': 'metsa raie kalkulaator',
					'eventAction': 'ava metsaraie kalkulaator'
				});
			} else if (activeCalculatorTab == "pollumajandusmaa") {
				dataLayer.push({
					'event': 'GAEvent',
					'eventCategory': 'põllumaa kalkulaator',
					'eventAction': 'ava põllumaa kalkulaator'
				});
			}

			console.log("click A", $active);

			e.preventDefault();

			if ($("#maaportaal-map-mobile").is(":visible")) {
				console.log("Maaportaal", Maaportaal);
				Maaportaal.initMap("maaportaal-map-mobile", {panel: false, height: true, zoomlevel: 2});
			}
		});
	});
	$('.module-avaleht ul.row-mobile-tabs a').on('click', function () {
		$("html, body").animate({
			scrollTop: 0
		}, 300);
	});
	$('.module-avaleht ul.row-mobile-tabs a').on('click', function () {
		$("html, body").animate({
			scrollTop: 0
		}, 300);
	});
	//SLICK
	$slickElement.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		loop: false
	});
	$slickElementLarge.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		loop: false

	});

	$(".slick-mobile-large-wrapper").each(function () {
		var $this = $(this);
		$('.slick-count-all', $this).html($('li', $this).length);
		if ($('.slick-count-all', $this).html() == 0) {
			$('.slick-count-all', $this).html(1);
		}
		$('.slick-mobile-arrow-right', $this).on("click", function () {
			$('.slick-mobile-large', $this).slick("slickNext");
		});
		$('.slick-mobile-arrow-left', $this).on("click", function () {
			$('.slick-mobile-large', $this).slick("slickPrev");
		});
	});

	$slickElementLarge.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		var i = (currentSlide ? currentSlide : 0) + 1;
		$('.slick-count-current', $(event.target).parent()).html(i);
	});
	//ACCORDION
	$(".toggle").click(function (e) {
		$slickElementLarge.slick("setPosition");
		e.preventDefault();
		var $this = $(this);

		$(".toggle").each(function (index, value) {
			console.log("!same", $this, ($this !== $this.get(0)));

			//if ($this.hasClass("tab-active") && $this !== $(this)) {
			if (this !== $this.get(0)) {
				$(this).removeClass("tab-active");
				$(this).parent().find("ul.inner").removeClass("show");
			}
		});

		if ($this.hasClass("tab-active")) {
			$this.removeClass("tab-active");
			$this.parent().find("ul.inner").removeClass("show");
		} else {
			$this.addClass("tab-active");
			$this.parent().find("ul.inner").addClass("show");
		}
		return false;
	});


	setTimeout(function () {
		$('.tab').on('click', function () {

			if (window.innerWidth < 769) {
				console.log('TAB SET')
				$slickElement.slick('setPosition');
			}

		});
	}, 300);


	var visible = false;

	/*function triggerBannerNavbar() {
        if (!MO.loggedIn()) {

            var docViewTop = $(window).scrollTop();
            var $mobileTabs = $('.mobile-tabs');
            var $triggerTabs = $('.trigger-tabs');
            if ($('.module-avaleht').length) {
                //console.log('docViewTop', docViewTop, 'isScrolledIntoVie', isScrolledIntoView(".trigger-tabs"), 'visible', visible);
                if (docViewTop >= 77 && !$triggerTabs.hasClass('triggered')) {
                    $mobileTabs.addClass('fixed');
                    if (visible == false) {

                    }
                }
                if (docViewTop <= 76) {
                    $triggerTabs.removeClass('triggered')
                    $mobileTabs.removeClass('fixed');
                }
                if (isScrolledIntoView(".banner-row")) {
                    $('.banner-row').addClass('auto-height');
                    $('.card-banner-wrapper').addClass('not-fixed');
                }
                if (isScrolledIntoView(".trigger-tabs") && docViewTop >= 77) {
                    visible = true;
                    $mobileTabs.addClass('fixed');
                    $triggerTabs.addClass('triggered')
                } else if (visible) {
                    visible = false;
                    $mobileTabs.removeClass('fixed');
                }

            }
        }
    }

    triggerBannerNavbar();
    $(window).scroll(function () {
        triggerBannerNavbar();
    });*/
	$('.scroll-terms').on('click', function (e) {
		$('.terms-box', $(this).parent()).animate({
			scrollTop: '+=1000'
		}, 100);

	});
}